<template>
  <div class="writer">
    <div class="left">
      <div>
        <div class="describe">
          <div>
            <el-image v-if="showData.head_picture" class="img" :src="showData.head_picture"></el-image>
          </div>

          <div class="describe-header">
            <div class="name">
              <div>{{ showData.name }}</div>
              <div class="operate">
                <!-- <div class="item" @click="chat">
                  <div class="item-left">
                    <el-image
                      style="width: 22px; height: 22px"
                      :src="require('@/assets/image/t20.png')"
                    ></el-image>
                  </div>
                  <div class="item-right">Chat</div>
                </div> -->
                <div class="item" @click="addToList" v-if="current != 1 && showData.is_collect != 1">
                  <div class="item-left">
                    <el-image style="width: 22px; height: 22px" :src="require('@/assets/image/t60.png')"></el-image>
                  </div>
                  <div class="item-right">Add to List</div>
                </div>
                <div class="item" @click="hire">
                  <div class="item-left">
                    <el-image style="width: 22px; height: 22px" :src="require('@/assets/image/t21.png')"></el-image>
                  </div>
                  <div class="item-right">Hire Writer</div>
                </div>
              </div>
            </div>

            <div class="detail">
              <div class="a">
                <span>{{ showData.rate }}</span>
                <el-rate class="ra" v-model="showData.score" :colors="['#577CF2', '#577CF2', '#577CF2']"
                  disabled></el-rate>
              </div>
              <div class="b">
                <span>{{ showData.orders }} Orders</span>
              </div>
              <div class="c">
                <span>{{ showData.reviews }} Reviews</span>
              </div>
              <div class="d">
                <span>{{ showData.pay_rate }}% Pay Rate</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="left-input">
        <el-input v-model="showData.message" :disabled="true" :autosize="{ minRows: 4, maxRows: 10 }"
          placeholder="A message from the writer" type="textarea"></el-input>
      </div>
    </div>

    <div class="right">
      <div class="right-text">writer's bid:</div>
      <img src="../../assets/image/bidding-lock.png" alt="" v-if="showData.status == 2" />
      <div :style="{ color: showData.status == 2 ? '#9A9B9F' : '#000' }">
        $ {{ showData.bid_amount }}
      </div>

      <div class="right-Tip" v-if="showData.is_new == 1">
        <img src="../../assets/image/news.png" />
      </div>

      <div v-if="showData.status == 2" class="right-Cancel">
        <i class="el-icon-error"></i>
        Bid was canceled by the writer
      </div>
    </div>

    <!-- <el-dialog class="dia" title="Commend" :visible.sync="visible" width="470px">
      <div slot="title">
        <div class="dia-box">
          <div>
            <i class="el-icon-back" @click="visible = false"></i>
            <span class="title">Hire:{{ showData.name }}</span>
          </div>

          <div>
            <i class="el-icon-circle-close" @click="visible = false"></i>
          </div>
        </div>
      </div>

      <div class="dia-main_content">
        <div>You're about to hire {{ showData.name }}.for this order. Contract total is：</div>
        <div class="dia-main_money">${{ showData.bid_amount }}</div>
        <div class="dia-main_balance">
          <div>Your Account Balance:</div>
          <div style="color: #ff4040">${{ userInfo.balance }}</div>
        </div>
      </div>

      <div slot="footer">
        <div class="btnArea">
          <el-button class="btn1" @click="visible = false">Cancel</el-button>
          <el-button class="btn2" @click="submit">Hire Writer</el-button>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog class="dia" title="Commend" :visible.sync="visible" width="470px">
      <div slot="title">
        <div class="dia-box">
          <div>
            <i class="el-icon-back" @click="visible = false"></i>
            <span class="title">Hire:{{ showData.name }}</span>
          </div>

          <div>
            <i class="el-icon-circle-close" @click="visible = false"></i>
          </div>
        </div>
      </div>

      <div class="dia-main_content">
        <div>You're about to hire {{ showData.name }}.for this order. Contract total is：</div>
        <div class="dia-main_money">${{ showData.bid_amount }}</div>
        <div class="dia-main_balance">
          <div>Your Account Balance:</div>
          <div style="color: #ff4040">${{ userInfo.balance }}</div>
        </div>
        <!-- 新增提示信息和充钱按钮 -->
        <div v-if="parseFloat(userInfo.balance) < parseFloat(showData.bid_amount)" class="recharge-tip">
          <div class="recharge-tip-text">Your balance is insufficient. Please recharge.</div>
          <el-button class="btn-recharge" @click="openRechargePage">Recharge</el-button>
        </div>
      </div>

      <div slot="footer">
        <div class="btnArea">
          <el-button class="btn1" @click="visible = false">Cancel</el-button>
          <el-button class="btn2" @click="submit" :disabled="parseFloat(userInfo.balance) < parseFloat(showData.bid_amount)">Hire
            Writer</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo, apiAddToList } from '@/api/api.js';
// hireResult说明:
//   0:未发送雇佣
//   1:发送了雇佣,待接受
//   2:待确认(包括用户发送雇佣和作家主动申请雇佣)
//   3:已确认,进入了写作环节
//   4:对方拒绝了雇佣
//   5:已经取消雇佣该作家
export default {
  props: ['showData', 'current'],
  name: 'writer',
  data: function () {
    return {
      visible: false,
      userInfo: {},
    };
  },
  computed: {
    value() {
      return parseFloat(this.showData.rate);
    },
  },
  watch: {
    visible(newVal, oldVal) {
      if (newVal) {
        this.getUserInfo();
      }
    },
  },
  methods: {
    async getUserInfo() {
      let result = await getUserInfo();
      console.log('getUserInfo result', result);
      result.type === 1
        ? (result.role = 'normal')
        : result.type === 2
          ? (result.role = 'writer')
          : console.log();
      this.userInfo = result;
    },
    chat() {
      let dataRoute = this.$router.resolve({
        path: '/writerPage/writerRecommend/writerOrderRequirmentsPage',
        query: { orderId: this.showData.order_id },
      });
      console.log('dataRoute', dataRoute);
      let { href } = dataRoute;
      console.log('href', href);
      let rootPath = this.getRootPath();
      console.log('rootPath', rootPath);
      let fullPath = rootPath + href;
      console.log('fullPath', fullPath);
      this.$router.push({
        name: 'chat',
        query: {
          id: this.showData.writer_id,
          orderId: this.showData.order_id,
          order_no: this.showData.order_number,
        },
        params: { content: fullPath },
      });
    },
    getRootPath() {
      var pathName = window.location.pathname.substring(1);
      var webName = pathName == '' ? '' : pathName.substring(0, pathName.indexOf('/'));
      //return window.location.protocol + '//' + window.location.host + '/'+ webName + '/';
      return window.location.protocol + '//' + window.document.domain + '/' + webName;
    },
    async addToList() {
      this.$confirm('add to list?', 'Tips', {
        confirmButtonText: 'comfirm',
        cancelButtonText: 'cancel',
        type: 'warning',
      })
        .then(async () => {
          await apiAddToList({
            id: this.showData.id,
          });
          this.$message.success('success');
          this.$emit('Refresh', true);
        })
        .catch(() => { });
    },
    hire() {
      this.visible = true;
      // this.$confirm('Are you sure you want to hire this writer?', 'Hint', {
      //   confirmButtonText: 'Confirm',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning',
      // })
      //   .then(() => {
      //     this.$emit('hire', this.showData.id);
      //   })
      //   .catch(() => {});
    },
    submit() {
      if (parseFloat(this.showData.bid_amount) <= parseFloat(this.userInfo.balance)) {
        this.$emit('hire', this.showData.id);
        this.visible = false;
      } else {
        this.$message.error('Insufficient account balance');
      }
    },
    openRechargePage() {
      // 打开充钱页面，这里可以根据实际情况修改跳转逻辑
      window.open('/h5/#/account/addFunds', '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
.recharge-tip {
  margin-top: 20px;

}

.recharge-tip-text {
  text-align: left;
}

.btn-recharge {
  margin-top: 10px;
  font-size: 18px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #fff;
  background: #577cf2;
  border: 1px solid #577cf2;
  padding: 10px 30px;
  border-radius: 20px;
  margin-left: 72%;
}

.writer {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eef1fd;

  .left {
    padding: 20px;
    box-sizing: border-box;
    width: 79%;
    background: #fff;

    .left-input {
      padding: 20px;
      padding-bottom: 0px;
    }

    .img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }

    .describe {
      margin-left: 20px;
      display: flex;
      align-items: center;
      box-sizing: border-box;

      .describe-header {
        width: 90%;
      }

      .name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 24px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #000000;
        margin-left: 20px;
      }

      .detail {
        margin-top: 10px;
        display: flex;
        align-items: center;

        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;

        .a {
          display: flex;
          align-items: center;

          .ra {
            margin-left: 5px;
          }
        }

        .b,
        .c,
        .d {
          margin-left: 20px;
        }
      }

      .operate {
        // margin-top: 20px;
        margin-left: 20px;
        display: flex;
        align-items: center;

        .item {
          background: rgba(87, 124, 242, 0.1);
          padding: 10px;
          display: flex;
          align-items: center;
          border-radius: 5px;
          cursor: pointer;

          .item-right {
            margin-left: 10px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
          }

          .close {
            color: #4d4dff;
            font-size: 20px;
          }
        }

        .item:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
  }

  .right {
    width: 20%;
    font-size: 42px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 500;
    color: #000000;
    background: #eef1fd;
    box-sizing: border-box;
    padding-left: 5%;
    position: relative;
    z-index: 99;
    min-width: 235px;

    .right-text {
      font-size: 18px;
      padding-left: 30px;
      color: #999;
      font-weight: 400;
      padding-left: 2%;
      z-index: 99;
    }

    .right-Tip {
      position: absolute;
      top: -50%;
      right: 50px;
      font-size: 12px;
      z-index: 99;
      width: 50px;
      height: 58px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .right-Cancel {
      font-size: 16px;
      color: #000;
      font-weight: 600;
      width: 180px;
      z-index: 99;
      z-index: 999;

      .el-icon-error {
        font-size: 22px;
        color: #ff0000;
      }
    }

    >img {
      // width: 100%;
      // height: 100%;
      height: 180px;
      width: 120px;
      position: absolute;
      right: 0px;
      opacity: 0.5;
      z-index: -1;
      bottom: -20%;
    }
  }
}

.dia {
  ::v-deep .el-dialog {
    background-color: #e6e8ec;
    border-radius: 10px;

    .dia-main_content {
      font-size: 18px;
      border-bottom: #eee solid 1px;
      padding-bottom: 20px;
    }

    .dia-main_money {
      font-size: 42px;
      font-weight: 600;
      padding: 20px 0px;
    }

    .el-button:disabled {
      background-color: #ccc;
      /* 灰色背景 */
      color: #666;
      /* 灰色文字 */
      cursor: not-allowed;
      /* 禁用鼠标样式 */
    }

    .dia-main_balance {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      font-size: 16px;
    }

    .el-dialog__header {
      padding: 15px;
      padding-bottom: 0;
      background-color: #e6e8ec;
      border-radius: 10px 10px 0 0;

      .el-dialog__headerbtn {
        display: none;
      }

      .el-icon-back {
        font-size: 24px;
        color: #577cf2;
      }

      .el-icon-circle-close {
        font-size: 24px;
        color: #577cf2;
        cursor: pointer;
      }

      .dia-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .title {
        margin-left: 20px;
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #577cf2;
        line-height: 40px;
      }
    }

    .el-dialog__body {
      background-color: #fff;
      padding: 30px 50px;
      border-radius: 10px 10px 0 0;
      padding-bottom: 0;

      // position: relative;
      // top: -20px;
      .se {
        width: 100%;

        input {
          background-color: #577bf225;
          color: #577cf2;
        }
      }

      .ta {
        margin-top: 40px;

        textarea {
          height: 170px;
          background-color: #fff;
        }

        textarea::-webkit-scrollbar {
          width: 10px;
          // height: 16px;
          background-color: rgba(87, 124, 242, 0.1);
        }

        textarea::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: rgba(87, 124, 242, 0.3);
        }
      }
    }

    .el-dialog__footer {
      background-color: #fff;
      text-align: right;
      border-radius: 0 0 10px 10px;
      padding: 10px;
      padding-bottom: 20px;

      // padding: 30px 50px;
      // position: relative;
      // top: -20px;
      .btnArea {
        margin-top: 20px;

        .btn1 {
          // background-color: #efeff1;
          // font-size: 20px;
          // border: 2px solid #efeff1;
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #577cf2;
          border: 1px solid #577cf2;
          padding: 10px 30px;
          border-radius: 20px;
        }
        .btn2:disabled {
          background-color: #ccc; /* 灰色背景 */
          color: #666; /* 灰色文字 */
          cursor: not-allowed; /* 禁用鼠标样式 */
          border-color: #ccc; /* 确保边框颜色也变为灰色 */
        }
        .btn2 {
          // background-color: #1eb05c;
          // color: #fff;
          // font-size: 20px;
          // border: 2px solid #1eb05c;
          // box-shadow: 0px 0px 8px 0px #1eb05c;

          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #fff;
          background: #577cf2;
          border: 1px solid #577cf2;
          padding: 10px 30px;
          border-radius: 20px;
        }
      }
    }
  }
}</style>
